import { render, staticRenderFns } from "./ChartBox.vue?vue&type=template&id=4894b8bb&scoped=true&"
import script from "./ChartBox.vue?vue&type=script&lang=js&"
export * from "./ChartBox.vue?vue&type=script&lang=js&"
import style0 from "./ChartBox.vue?vue&type=style&index=0&id=4894b8bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894b8bb",
  null
  
)

export default component.exports